import { render } from "./ResponseGrid.vue?vue&type=template&id=01219e73&scoped=true"
import script from "./ResponseGrid.vue?vue&type=script&lang=js"
export * from "./ResponseGrid.vue?vue&type=script&lang=js"

import "./ResponseGrid.vue?vue&type=style&index=0&id=01219e73&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01219e73"]])

export default __exports__